<!--  -->
<template>
  <div class="wrapper">
    <div class="statistics-info">
      <div class="statistics-info-item">
        <h3 class="statistics-info-title">Data Statistics</h3>
        <div class="statistics-info-body">
          <div class="statistics-data-list">
            <div class="widget">
              <span class="type">Species</span>
              <span class="number">103,818</span>
              <span class="cf"><b>Cf.yday</b> <i class="cf-number" :class="[currentClass]">20</i></span>
            </div>
            <div class="widget">
              <span class="type">Literature</span>
              <span class="number">103,818</span>
              <span class="cf"><b>Cf.yday</b> <i class="cf-number down">20</i></span>
            </div>
            <div class="widget">
              <span class="type">Fossil</span>
              <span class="number">103,818</span>
              <span class="cf"><b>Cf.yday</b> <i class="cf-number up">20</i></span>
            </div>
            <div class="widget">
              <span class="type">Glossary</span>
              <span class="number">103,818</span>
              <span class="cf"><b>Cf.yday</b> <i class="cf-number equal">0</i></span>
            </div>
            <div class="widget">
              <span class="type">Frontend Visitor</span>
              <span class="number">103,818</span>
              <span class="cf"><b>Cf.yday</b> <i class="cf-number down">20</i></span>
            </div>
          </div>
          <div class="statistics-member-task">
            <div class="member-task-item">
              <dl>
                <dt>Admin Member</dt>
                <dd>
                  <span><b>已激活用户</b> <i>79</i></span>
                  <span><b>数据录入员</b> <i>79</i></span>
                  <span><b>被冻结用户</b> <i>79</i></span>
                  <span><b>数据小组长</b> <i>79</i></span>
                  <span><b>已激活用户</b> <i>79</i></span>
                </dd>
              </dl>
            </div>
            <div class="member-task-item">
              <dl>
                <dt>Download Task</dt>
                <dd>
                  <span><b>下载任务</b> <i>79</i></span>
                  <span><b>执行完成</b> <i>79</i></span>
                  <span><b>等待执行</b> <i>79</i></span>
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
      <div class="statistics-info-item">
        <h3 class="statistics-info-title">Server Information</h3>
        <div class="server-info-body">
          <div class="member-task-item">
            <dl>
              <dt>Server</dt>
              <dd>
                <span><b>CPU Number</b> <i>79</i></span>
                <span><b>System Uptime</b> <i>234563345t34re</i></span>
                <span><b>Proces Uptime</b> <i>567890-6789</i></span>
                <span><b>Total Number</b> <i>6778906789.678MB</i></span>
                <span><b>Free Memory</b> <i>56890.tyuiMB</i></span>
                <span><b>Free Percentage</b> <i>0333%</i></span>
              </dd>
              <dd>
                <el-progress :percentage="50"></el-progress>
              </dd>
            </dl>
          </div>
          <div class="member-task-item load-average">
            <dl>
              <dt>Load Average</dt>
              <dd>
                <span><b>Real Time</b> <i>79</i></span>
                <span><b>1min</b> <i>234563345t34re</i></span>
                <span><b>5min</b> <i>567890-6789</i></span>
                <span><b>15min</b> <i>567890-6789</i></span>
              </dd>
              <dd class="my-chart">
                <div id="myChart"></div>
              </dd>
            </dl>
          </div>
          <div class="member-task-item">
            <dl>
              <dt>Network</dt>
              <dd></dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentClass: "up",
    };
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this.$nextTick(() => {
      this.initEchart();
    });
  },
  methods: {
    initEchart() {
      let dom = document.getElementById("myChart");
      console.log(dom);
      let myChart = this.$echarts.init(dom);
      myChart.setOption({
        xAxis: {
          show: false,
          type: "category",
          boundaryGap: false,
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        },
        yAxis: {
          show: false,
        },
        series: [
          {
            smooth: true,
            data: [820, 932, 901, 934, 1290, 1330, 1320],
            type: "line",
            symbol:"none",
            areaStyle: {
              colorStops: [
                {
                  offset: 0,
                  color: "#3899c5", // 0% 处的颜色
                },
                {
                  offset: 0.95,
                  color: "#3899c5",
                },
                {
                  offset: 1,
                  color: "#2c90cd", // 100% 处的颜色
                },
              ],
            },
          },
        ],
        grid: [
          {
            left: 0,
            bottom: 0,
            top: 0,
            right: 0,
            backgroundColor: "red",
          },
        ],
      });
    },
  },
};
</script>
<style>
.statistics-info-item {
  margin-bottom: 20px;
}
.statistics-info {
  width: 100%;
}
.statistics-info-title {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 48px;
  color: #484d63;
}
.statistics-data-list {
  display: flex;
  justify-content: space-between;
}
.widget {
  width: 19.5%;
  margin-right: 8px;
  height: 128px;
  border: 2px solid #efefef;
  box-sizing: border-box;
  padding: 15px 20px;
  display: flex;
  flex-direction: column;
}
.statistics-data-list .widget:last-child {
  margin-right: 0;
}
.widget span {
  /* width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; */
  width: 100%;
}
.member-task-item dl dt,
.widget .type {
  font-size: 16px;
  line-height: 18px;
  margin-bottom: 10px;
  color: rgba(72, 77, 99, 0.7);
}
.widget .number {
  font-family: Roboto;
  font-size: 32px;
  line-height: 38px;
  margin-bottom: 4px;
  color: #484d63;
}
.widget .cf b {
  display: inline-block;
  vertical-align: middle;
  font-size: 16px;
  line-height: 18px;
  color: rgba(72, 77, 99, 0.7);
}
.widget .cf .cf-number {
  display: inline-block;
  vertical-align: middle;
  max-width: 70%;
  padding: 0 15px 0 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 16px;
  line-height: 37px;
  color: #484d63;
}
.cf-number.up {
  background: url("../assets/images/num_up.png") no-repeat right center;
  background-size: 9px 12px;
}
.cf-number.down {
  background: url("../assets/images/num_down.png") no-repeat right center;
  background-size: 9px 12px;
}
.cf-number.equal {
  background: url("../assets/images/num_equal.png") no-repeat right center;
  background-size: 9px 2px;
}
.statistics-member-task {
  display: flex;
  justify-content: flex-start;
  margin-top: 8px;
  overflow: hidden;
}

.member-task-item {
  width: 100%;
  padding: 15px 20px;
  /* float: left; */
  margin-right: 8px;
  margin-bottom: 8px;
  border: 2px solid #efefef;
  box-sizing: border-box;
  overflow: hidden;
}
.statistics-member-task .member-task-item:last-child {
  margin-right: 0;
  width: calc(39% + 8px);
}
.statistics-member-task .member-task-item {
  width: calc(58.5% + 18px);
  height: 116px;
}

.member-task-item dl dd {
  width: 100%;
  height: calc(100% - 30px);
  display: flex;
  /* justify-content: space-between; */
  flex-wrap: wrap;
  align-items: center;
}

.member-task-item dl dd span {
  width: 33.333%;
  color: rgba(72, 77, 99, 0.7);
}
.load-average dl dd span {
  width: 25%;
}

.member-task-item dl dd span b {
  display: inline-block;
  width: 100px;
  vertical-align: middle;
  margin-bottom: 8px;
}

.member-task-item dl dd span i {
  color: #484d63;
  display: inline-block;
  width: calc(100% - 130px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
  margin-bottom: 8px;
}
.load-average .my-chart {
  width: 100%;
  height: 194px;
}
#myChart {
  width: 100%;
  height: 100%;
  background: #85d09e;
}
.server-info-body .member-task-item dl dd span b {
  width: 150px;
}
.server-info-body .member-task-item dl dd span i {
  width: calc(100% - 180px);
}
.load-average dl dd span:not(:first-child) b {
  width: 50px;
}
.server-info-body .el-progress {
  width: 100%;
}
.server-info-body .el-progress-bar__outer {
  background-color: #efefef;
  border-radius: 0;
}
.server-info-body .el-progress-bar__inner {
  background-color: #85d09e;
  border-radius: 0;
}
</style>